var _style, _g, _g2, _g3, _ellipse, _path, _path2, _path3, _path4, _path5, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _path6, _path7, _g4, _ellipse2, _path8, _path9, _path10, _g5, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _path11, _path12, _path13, _path14, _path15, _path16, _ellipse3, _ellipse4, _polygon13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCemetery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 960 650",
    style: {
      enableBackground: "new 0 0 960 650"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#720091;stroke:#000000;stroke-miterlimit:10;}\n\t.st1{fill:#220E28;}\n\t.st2{fill:#3B1F44;}\n\t.st3{fill:#1F4227;stroke:#000000;stroke-miterlimit:10;}\n\t.st4{opacity:0.5;fill:#172119;}\n\t.st5{fill:#4F2F5B;stroke:#000000;stroke-miterlimit:10;}\n\t.st6{opacity:0.3;fill:#29202D;}\n\t.st7{fill:#EABA65;}\n\t.st8{fill:#AA864D;}\n\t.st9{opacity:0.7;fill:#B286B7;}\n\t.st10{fill:#341B35;}\n\t.st11{fill:#395416;stroke:#000000;stroke-miterlimit:10;}\n\t.st12{fill:url(#pumpkin_1_);stroke:#000000;stroke-miterlimit:10;}\n\t.st13{fill:url(#smile_1_);stroke:#000000;stroke-miterlimit:10;}\n\t.st14{fill:url(#eyeR_2_);stroke:#000000;stroke-miterlimit:10;}\n\t.st15{fill:url(#eyeL_2_);stroke:#000000;stroke-miterlimit:10;}\n\t.st16{fill:none;stroke:#000000;stroke-miterlimit:10;}\n\t.st17{opacity:0.49;fill:#91321C;}\n\t.st18{opacity:0.51;fill:#253A0E;}\n\t.st19{fill:#747534;stroke:#000000;stroke-miterlimit:10;}\n\t.st20{fill:#565630;stroke:#000000;stroke-miterlimit:10;}\n\t.st21{fill:#494926;stroke:#000000;stroke-miterlimit:10;}\n\t.st22{fill:#301635;}\n\t.st23{fill:url(#candle_2_);stroke:#000000;stroke-miterlimit:10;}\n\t.st24{fill:url(#plate_1_);stroke:#000000;stroke-miterlimit:10;}\n\t.st25{opacity:0.71;fill:url(#XMLID_22_);stroke:#7F0000;stroke-miterlimit:10;}\n\t.st26{opacity:0.75;}\n\t.st27{stroke:#000000;stroke-miterlimit:10;}\n\t.st28{fill:#999999;stroke:#000000;stroke-miterlimit:10;}\n\t.st29{opacity:0.15;fill:#FCFAFA;}\n\t.st30{opacity:0.14;fill:#FCFAFA;}\n\t.st31{opacity:0.13;fill:#FCFAFA;}\n\t.st32{opacity:0.24;}\n\t.st33{opacity:0.23;}\n\t.st34{fill:#603813;stroke:#000000;stroke-miterlimit:10;}\n\t.st35{fill:url(#XMLID_24_);stroke:#000000;stroke-miterlimit:10;}\n\t.st36{fill:url(#XMLID_25_);stroke:#000000;stroke-miterlimit:10;}\n\t.st37{fill:#A67C52;}\n\t.st38{fill:#A67C52;stroke:#000000;stroke-miterlimit:10;}\n\t.st39{opacity:0.66;fill:#A479AA;}\n\t.st40{opacity:0.76;fill:#CB9CD3;}\n\t.st41{fill:#4F3723;}\n\t.st42{stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\n\t.st43{fill:#42210B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "backGround"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ground"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "sky_1_",
    className: "st0",
    points: "960,650 0,650 0,356 0,325 0,315 0,0 960,0  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hills_1_",
    className: "st1",
    d: "M959.3,443.5L0,448.5l-0.1-81c0,0,151.5-80.7,163.2-116.1S277.2,343,277.2,343 s95.5,53.5,161.4-48.8S584.1,253,584.1,253s83.4,83.3,173.2,47.2s119.7-65.1,165.1-54.6c18.1,4.1,30,15.9,37.6,31.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ground_1_",
    className: "st2",
    d: "M-0.2,406.8c0,0,75.2-23.8,163.2-7.8c0,0,54,14,83,26c0,0,48,18,144-20s83-46,184-42 c0,0,74.5,0.7,172.5,9.8c0,0,102.5-39.8,212.5-20.8v298.5L-0.2,649V406.8z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "grass3",
    className: "st3",
    d: "M175.2,562.3c0,0-4.9-25.6-30.9-36.1c0,0,41.5,6.3,43.9,26.8c0,0,10.2-27-7-40.6 c0,0,20.3,10.4,17.9,34.4c-0.1,1.1,0.1,4.8,0,5.9c-1,10.9,2.9,11.1-8.7,9.9C182.9,561.8,175.2,562.3,175.2,562.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "grass2",
    className: "st3",
    d: "M692,436.5c-6.6,0-13.2-0.4-13.2-0.4s-4.2-22.2-26.7-31.3c0,0,35.9,5.4,38,23.2 c0,0,8.8-23.4-6-35.1c0,0,17.6,9,15.5,29.8c0,0,5.5-0.3,8-3.9c3-4.3,3.2-12.3,5.4-15.4c0,0,1.3,10.5-2.2,19.2 c-2.9,7.3-10.6,13-12.6,14H692z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "grass1",
    className: "st3",
    d: "M835.2,605.2c0,0-6.5-34.5-41.6-48.6c0,0,55.9,8.5,59.1,36.1c0,0,13.7-36.4-9.4-54.6 c0,0,27.4,14.1,24.1,46.3c-0.2,1.5,0.1,6.5,0,7.9c-1.4,14.6,4,15-11.7,13.4C845.6,604.6,835.2,605.2,835.2,605.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "grasssshadow3",
    className: "st4",
    d: "M175.2,562.3c0,0-2.2-23.3-30.9-36.1C144.3,526.2,183.7,535.2,175.2,562.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "grassShadow2",
    className: "st4",
    d: "M678.8,436.1c0,0-0.3-3.8-3.9-10.5c-1.1-2.1-2.8-5.3-5.1-7.7c-3.7-3.9-7.4-9.1-15.5-12.7 C654.3,405.2,687.3,409,678.8,436.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "grasShadow1",
    className: "st4",
    d: "M834.6,605.6c0,0-2-30.9-39.5-49.1C795.2,556.5,847,570.1,834.6,605.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rock1",
    className: "st5",
    d: "M286.4,520.7c0,0-12-29.3,17.1-33.7c10.3-1.6,21.6,4.9,31.8,5.5c18.5,1.1,33.6-2.1,33.6-2.1 s20.9,8.2,17.3,28.4L286.4,520.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rock2",
    className: "st5",
    d: "M580,448.5h-41.6c0,0-12-29,17.1-34C555.5,414.5,570.5,414,580,448.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st6",
    d: "M286.4,520.7c0,0-12.3-29.3,18.6-34l8.3,33.2L286.4,520.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    className: "st6",
    d: "M538.4,448.7c0,0-12.3-29.3,18.6-34l8.3,33.2L538.4,448.7z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "sky"
  }, /*#__PURE__*/React.createElement("g", {
    id: "moonAll"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "moon",
    className: "st7",
    cx: 794.9,
    cy: 152.1,
    r: 54.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "moonHole1",
    className: "st8",
    cx: 805.3,
    cy: 128.5,
    r: 10.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "moonHole2",
    className: "st8",
    cx: 828.6,
    cy: 139.7,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "moonHole3",
    className: "st8",
    cx: 812.7,
    cy: 144.8,
    r: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st8",
    d: "M801,206.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "moonHalfShadow",
    className: "st8",
    d: "M804.9,204c-30.3,0-54.9-24.6-54.9-54.9c0-23,14.1-42.6,34.2-50.8 c-25.2,5-44.2,27.2-44.2,53.8c0,30.3,24.6,54.9,54.9,54.9c7.3,0,14.3-1.4,20.7-4C812.1,203.6,808.5,204,804.9,204z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "cloud1_2_",
    className: "st9",
    d: "M652.2,222.3l2.9,10.3c0.8,2.6,5,5.9,8.6,5.8l169.9,0.4c4.7-0.1,8.1-3.4,7-6.8l-2.2-7.3 c-1-3.5,2.5-6.8,7.3-6.8h100.1c4.9,0,8.4-3.4,7.3-6.9l-3.9-11.8c-0.8-2.5-3.8-4.2-7.3-4.2H837.8c-3.2,0-6-1.5-7.1-3.7L825,179 c-1-2.2-3.9-3.7-7.1-3.7h-61.2c-5.1,0-8.7,3.7-7.1,7.3l2.9,6.6c1.6,3.6-2.1,7.4-7.2,7.3l-111.2-1.3c-2.8,0-5.4-1.3-6.6-3.2 l-5.2-8.2c-1.2-1.9-3.9-3.2-6.8-3.2h-23.8c-5.4,0-9,4.1-6.8,7.8l2.1,3.5c2.2,3.7-1.4,7.8-6.8,7.8h0c-5,0-8.6,3.6-7.1,7.2l2.7,6.5 c0.9,2.3,3.8,3.9,7,3.9l62.4,0.6C648.5,217.9,651.5,219.8,652.2,222.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cloud2",
    className: "st9",
    d: "M491.4,117.3l3.6,13.5c0.9,3.5,6.1,7.7,10.5,7.6l205.6,0.5c5.7-0.2,9.7-4.4,8.5-8.9l-2.6-9.6 c-1.2-4.5,3-8.9,8.8-8.9h121.1c5.9,0,10.2-4.4,8.8-9l-4.7-15.4c-1-3.3-4.6-5.5-8.8-5.5H715.9c-3.9,0-7.3-2-8.5-4.9l-7-16.2 c-1.3-2.9-4.7-4.9-8.5-4.9h-74.1c-6.2,0-10.5,4.9-8.6,9.6l3.6,8.7c2,4.8-2.5,9.7-8.7,9.6l-134.6-1.8c-3.4,0-6.5-1.7-8-4.2 l-6.3-10.7c-1.5-2.5-4.7-4.2-8.2-4.2h-28.8c-6.5,0-10.9,5.4-8.3,10.2l2.5,4.6c2.6,4.8-1.7,10.2-8.3,10.2h0c-6.1,0-10.4,4.7-8.6,9.4 l3.2,8.5c1.1,3,4.6,5.1,8.5,5.2l75.5,0.8C486.9,111.6,490.5,114,491.4,117.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cloud3",
    className: "st9",
    d: "M98.2,161.7l2.9,13.5c0.7,3.5,4.9,7.7,8.4,7.6l165.7,0.5c4.6-0.2,7.9-4.4,6.9-8.9l-2.1-9.6 c-1-4.5,2.5-8.9,7.1-8.9h97.6c4.7,0,8.2-4.4,7.1-9l-3.8-15.4c-0.8-3.3-3.7-5.5-7.1-5.5H279.2c-3.1,0-5.9-2-6.9-4.9l-5.6-16.2 c-1-2.9-3.8-4.9-6.9-4.9h-59.7c-5,0-8.5,4.9-6.9,9.6l2.9,8.7c1.6,4.8-2,9.7-7,9.6l-108.5-1.8c-2.8,0-5.3-1.7-6.5-4.2L69,111.2 c-1.2-2.5-3.8-4.2-6.6-4.2H39.2c-5.3,0-8.8,5.4-6.7,10.2l2,4.6c2.1,4.8-1.4,10.2-6.7,10.2h0c-4.9,0-8.4,4.7-7,9.4l2.6,8.5 c0.9,3,3.7,5.1,6.9,5.2l60.9,0.8C94.6,156,97.5,158.4,98.2,161.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "pumpkins"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PumpkinAll"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_8_",
    className: "st10",
    cx: 829.8,
    cy: 515.5,
    rx: 76.8,
    ry: 16.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "stalk",
    className: "st11",
    d: "M818.5,416.8c0,0,3.5-1.8,4.5-4.2c0,0,1.3-22,7.7-25.3c0,0,6.2,0.2,7.3,0c1.2-0.2,2,5,0,5.5 c0,0-1.7,12,3.3,21.8L818.5,416.8z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "pumpkin_1_",
    cx: 834.8174,
    cy: 461.7359,
    r: 57.8205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1566,
    style: {
      stopColor: "#D7D11C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5051,
    style: {
      stopColor: "#EA801F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8889,
    style: {
      stopColor: "#D1510D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CF4C0B"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "pumpkin",
    className: "st12",
    d: "M805.7,512c0,0-33.3-7-34-47.7c0,0-3.7-41,38.3-48l9.5-1.7c0,0,2.5,1.5,6.2,0c0,0,3.2,1,5,0 c0,0,5.8,1.3,6.8-1.2c0,0,2.7-1.7,5-1.2l-1.7-1.5c0,0,1.7-1.2,7.7,0c0,0,6.2-2.3,15.3,0.3c9.2,2.7,26,10.2,32.8,37.7 c6.8,27.5-12.8,61.2-33.3,63.2c0,0-3,1-8.7-1.2c0,0-6.3,3.3-17,2.5c0,0-14.2,1-16.8-1C820.8,512.3,812.7,513.5,805.7,512z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "smile_1_",
    cx: 836.1262,
    cy: 471.6314,
    r: 34.1706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2677,
    style: {
      stopColor: "#D7D11C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7374,
    style: {
      stopColor: "#A24C0B"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "smile",
    className: "st13",
    d: "M791.8,464.9c0,0,13.5,32.6,56.8,24.6V481l12.3-4.5l1.3,5.8c0,0,18.8-12.8,18.5-29.8 c0,0-6.8,20.8-53,20.5l-0.3,7.3l-15.8-1.3l1-9L791.8,464.9z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eyeR_2_",
    cx: 813.875,
    cy: 446.6519,
    r: 15.3106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2677,
    style: {
      stopColor: "#D7D11C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7374,
    style: {
      stopColor: "#A24C0B"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "eyeR",
    className: "st14",
    d: "M794.8,451.3l7.8-14.8L833,450C833,450,812.2,464.4,794.8,451.3z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eyeL_2_",
    cx: 855.875,
    cy: 442.1111,
    r: 14.5317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2677,
    style: {
      stopColor: "#D7D11C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7374,
    style: {
      stopColor: "#A24C0B"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "eyeL",
    className: "st15",
    d: "M838.8,450.3l27-19.5l7.3,9.8C873,440.5,868.8,461.3,838.8,450.3z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "nose",
    className: "st16",
    points: "834.8,464.5 838.8,456.4 845.8,464.5  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "shadow1",
    className: "st17",
    points: "820.8,512.3 815.9,487.2 806.7,482.3  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "shadow2",
    className: "st17",
    points: "822.9,416.4 817.9,444 810.3,439.6  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    id: "shadow3",
    className: "st17",
    points: "807.2,457.1 810.3,457.4 808.8,468.7 804.9,467.8  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    id: "shadow4",
    className: "st17",
    points: "854.7,510.3 861.8,483 868.8,477.4  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    id: "shadow5",
    className: "st17",
    points: "860.6,453.5 863.6,452.5 867.1,465 863.2,467.3  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    id: "shadow6",
    className: "st17",
    points: "840.6,413.2 854.7,438.1 859.8,434.3  "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "shadow7",
    className: "st18",
    d: "M835.9,393.5c0,0-0.9,10.8,3.5,19.3l-1.6,0.9C837.7,413.7,832.1,404.3,835.9,393.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "shadow8",
    className: "st18",
    d: "M831.8,393.5c0,0-2.9,12.3-1.3,21.7l-1.8,0.3C828.6,415.5,824.8,402.6,831.8,393.5z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "graves"
  }, /*#__PURE__*/React.createElement("g", {
    id: "croos1"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_6_",
    className: "st19",
    points: "193.9,462.2 164.5,342.5 104.5,352 100,330.1 161,319 148.8,264 179,260.5 189,315  240,305 243.7,327 194,337.5 221,457.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7_",
    className: "st20",
    points: "193.9,462.2 182,457 153.9,344.2 164.5,342.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_9_",
    className: "st20",
    points: "104.5,352 91.5,346.9 87.5,325 152,315.3 141,258 167.5,254.5 179,260.5 148.8,264  161,319 100,330.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_10_",
    className: "st20",
    points: "188.1,310.1 228,303.3 240,305 189,315  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "grave1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    className: "st19",
    d: "M386.6,441.3l57.8,15.5l16.6-114.3c0,0-19.8-101.2-65.8-11L386.6,441.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    className: "st21",
    d: "M444.3,456.8l16.6-3.3l15.8-109.8c0,0-3.5-38.5-26.5-47.3l-18.7-2.4c0,0,19.1,3.5,29.1,47.4 L444.3,456.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "candle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4_"
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    className: "st22",
    cx: 231.6,
    cy: 485.7,
    rx: 16.9,
    ry: 5.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "candle_2_",
    cx: 233.5791,
    cy: 450.9424,
    r: 12.4963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0572408,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2172,
    style: {
      stopColor: "#FDD9A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    style: {
      stopColor: "#FCBD5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4057,
    style: {
      stopColor: "#FBB23F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6298,
    style: {
      stopColor: "#FD9C18"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7946,
    style: {
      stopColor: "#FF8F00"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "candle_1_",
    className: "st23",
    d: "M226.3,473.6v-27c0-1.8,1.5-3.3,3.3-3.3h4.2c1.8,0,3.3,1.5,3.3,3.3v27c0,1.8-1.5,3.3-3.3,3.3 h-4.2C227.8,476.9,226.3,475.4,226.3,473.6z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "plate_1_",
    cx: 229.245,
    cy: 479.517,
    r: 9.5704,
    fx: 228.5642,
    fy: 479.4822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05724121,
    style: {
      stopColor: "#999999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07384036,
    style: {
      stopColor: "#979695"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3529,
    style: {
      stopColor: "#776B4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4832,
    style: {
      stopColor: "#6B5A34"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8502,
    style: {
      stopColor: "#493D34"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "plate",
    className: "st24",
    d: "M240.4,473.5h-17.3c-2.1,0-3.6,2-3,4.1l1.4,4.6c0.2,0.7,0.6,1.3,1.2,1.7 c2.5,1.7,9.7,5.5,17.6-0.1c0.5-0.4,0.9-0.8,1.1-1.4l1.9-4.5C244.1,475.8,242.6,473.5,240.4,473.5z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_22_",
    cx: 230.9963,
    cy: 431.1154,
    r: 6.4884,
    fx: 230.5347,
    fy: 431.0917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FAE33D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6212,
    style: {
      stopColor: "#E25852"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9916,
    style: {
      stopColor: "#892A2A"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    className: "st25",
    d: "M228,439.1c0,0,1.7,2.5,6.8,0s-0.4-5.9-3.4-15.6c0,0-1.5,4.6-3.4,6.8 C226.1,432.6,228,439.1,228,439.1z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "yurei"
  }, /*#__PURE__*/React.createElement("g", {
    id: "yurei_1_",
    className: "st26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hairs",
    className: "st27",
    d: "M423,227.7c0,0-37.7-38.3-51.7,9.7c0,0-4,4.4-5.3,31.9c0,0-4,27.5,0,63.5S343.3,378,343.3,378 s23.3-0.7,30-18.3c0,0,4.7,2-1.3,15.2c0,0,11-0.9,14.7-10.5c0,0-7.7-45.6,4.3-69.1c0,0,3.7-12.5,24.3-14.2 C415.3,281,425.1,275.3,423,227.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "body",
    className: "st28",
    d: "M413.3,281c0,0,9.9,4.3,8,18.5c0,0-1.8,32.4,11.3,88.3s-3.2,120.9-3.2,120.9s-0.7-12.7-10.7-7.3 c-10,5.3-19.7-2-19.7-2s-15.7-3.7-17.7,1.7c-2,5.3-19-5-19-5s-9-6.3-13.3,0s1.2-37,38.6-84c0,0,4.1-31.7-2.9-47.7 S378.7,278.7,413.3,281z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reflection3",
    className: "st29",
    d: "M378.2,228c1.3,0.8,2.7,2.1,3,4.3c0.2,1.7,2,2.6,3.4,1.6c3.1-2.1,6.5-5.4,5-8.8 c-2.2-4.8,6.1-1,8.1,4.9c0.5,1.5,2.4,2.1,3.6,1c2.4-2.3,4.8-5.5,2.5-8.1c-3.1-3.4,4.4-2.8,8,1.8c1.2,1.6,3.8,1,4-1 c0-0.2,0-0.3-0.1-0.4c-0.6-0.4-13.7-11.4-24.9-8c-7.5,2.3-11.5,6.8-13.3,9.5C376.8,225.9,377.1,227.4,378.2,228z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reflection2",
    className: "st30",
    d: "M379,316.5c0,0,4.5-40.8,29.5-40.1s-22.9-8.1-25.2,5.6C381,295.8,379.5,289.8,379,316.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reflection1",
    className: "st31",
    d: "M368.8,338.7c0,0,3.2-20.7,5.7,0c0,0,1.3,4.5,3.2,1.2c1.8-3.3,1.5-12.3,2.8-0.2 c0,0-2.8,18.2-3.3,4.2c0,0-4.2-2.2-4,0.2c0.2,2.3-4.7,18.5-5,2.5C367.8,330.5,368.8,338.7,368.8,338.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shadow5_1_",
    className: "st32",
    d: "M375.2,499.9c-2.5-0.5-4-3.1-3-5.5c5.5-13.8,21.2-54.4,23.3-69.7c0,0-6.8,55.4-14.9,74.5 c-0.4,1-1.6,1.6-2.6,1.3C377.3,500.3,376.4,500.1,375.2,499.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shadow4_1_",
    className: "st32",
    d: "M409.6,501c-2.6-0.2-4.3-2.7-3.6-5.1c3.8-14.3,14.7-56.5,15-71.9c0,0-0.2,55.8-6,75.7 c-0.3,1.1-1.4,1.8-2.5,1.6C411.8,501.2,410.9,501.1,409.6,501z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shadow3_1_",
    className: "st32",
    d: "M349.8,492.5c0,0,2.3-4.2,6.8-2c0,0,0.2-19.8,11.8-39C368.5,451.5,355.8,466.3,349.8,492.5z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "shadow2_1_",
    className: "st33",
    d: "M404.8,285.3c0,0-4.4,6,4.8,3.3c0,0-15.5,4.8-14.5,35.8C395,324.3,390.1,296.7,404.8,285.3z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "shadow1_1_",
    className: "st33",
    d: "M397.4,344.7c0,0-6.5,7.3,16.1,47.5c0,0,3.9,5.9,5.6,17.9c0,0,0.2-17-5.6-28.7 C407.7,369.7,398.4,355,397.4,344.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shadow5_2_",
    className: "st32",
    d: "M429.6,502.4c0,0-0.9-4.7-5.9-4c0,0,6.8-41.2,1.7-63.1C425.5,435.3,432.1,475.6,429.6,502.4 z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "ghost1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ghostOneLantern"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_21_"
  }, _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    id: "lanternShape",
    className: "st34",
    points: "487.5,461.5 503.4,470 532.9,464.5 533.7,401.2 516.5,383.2 516.5,371.5  501.5,371.5 501.5,382.1 486.6,401.1  "
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_24_",
    cx: 494.4102,
    cy: 434.9131,
    r: 21.4628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5152,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5389,
    style: {
      stopColor: "#FFFBF4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7667,
    style: {
      stopColor: "#FDD391"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9252,
    style: {
      stopColor: "#FBBA53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBB03B"
    }
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_5_",
    className: "st35",
    points: "488.3,405.2 489.3,459 500.5,464.6 500.5,407.4  "
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_25_",
    cx: 519,
    cy: 435.6499,
    r: 21.9898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5152,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5389,
    style: {
      stopColor: "#FFFBF4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7667,
    style: {
      stopColor: "#FDD391"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9252,
    style: {
      stopColor: "#FBBA53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBB03B"
    }
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_14_",
    className: "st36",
    points: "507.5,464.5 530.5,460.4 530.5,406.8 507.5,408.9  "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_17_",
    className: "st37",
    points: "488.2,401.1 500.5,386 503.9,386 500.5,403.7  "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_18_",
    className: "st37",
    points: "530.8,401.3 515.9,386 508.4,386 505.2,403.7  "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_23_",
    className: "st38",
    d: "M505,370.5c-0.3-1-0.5-1.6-0.5-2.4c0-2.6,2.1-4.8,4.7-4.8c2.6,0,4.7,2.2,4.7,4.8 c0,0.8-0.2,1.3-0.5,2.3h1.9c0.2-1,0.4-1.5,0.4-2.3c0-3.5-2.8-6.4-6.3-6.4c-3.5,0-6.3,3-6.3,6.5c0,0.7,0.1,1.2,0.4,2.2H505z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "ghost",
    className: "st39",
    d: "M635,261c0,0-49-9-27,42c0,0,13.5,7.5,6.5,21.5s-87.5,172,72,211.2s47.5-38.9,47.5-38.9 s39.2,53.7,10.6,30.7C716,504.5,682.5,484,683,429C683,429,735.5,327,635,261z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "hand",
    className: "st34",
    d: "M586.4,266.5c13.5,3.2,49,9.9,91.2,5.6c2.2-0.2,2.5-3.3,0.5-4l-31.5-10.9 c-0.9-0.3-1.5-1.2-1.4-2.2l1.2-9.4l1.5-12.1c0.1-1.1-0.7-2.2-1.8-2.3l-34.4-4c-1.2-0.1-2.3,0.8-2.3,2l-0.1,7.2l0,1.7l-0.1,7.4 l-0.1,5.6c0,0.8-0.5,1.5-1.2,1.8l-21.8,9.6C584.2,263.4,584.5,266,586.4,266.5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "handL",
    className: "st40",
    d: "M648.2,337.5c-0.2,13-40.7,36-93.2,10c0,0-47.5-15-52,6.5s12.5,10.5,12.5,10.5s2.5-18.5,36.5-3 c0,0,99.5,33.3,112.5-13S648.2,337.5,648.2,337.5z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "mustacheL",
    className: "st41",
    d: "M611.3,293.8c0,0-14.8-2-12.5,8.8c0,0,1.3,7.3-5,8.5c0,0,14.3-0.3,15.4-7.3 c1.1-7,6.6-6.2,6.6-6.2L611.3,293.8z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "mustache1",
    className: "st41",
    d: "M611.3,293.8c0,0,14.8-2,12.5,8.8c0,0-1.3,7.3,5,8.5c0,0-14.3-0.3-15.4-7.3 c-1.1-7-6.6-6.2-6.6-6.2L611.3,293.8z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "eyeL_1_",
    className: "st42",
    cx: 614.6,
    cy: 283.1,
    rx: 2.9,
    ry: 4.1
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "eyeR_1_",
    className: "st42",
    cx: 606.6,
    cy: 282.1,
    rx: 2.9,
    ry: 4.1
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_20_",
    className: "st43",
    points: "608.7,251.6 645.7,255 646.6,246.9 609,243.2  "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCemetery);
export default __webpack_public_path__ + "static/media/cemetery.f9f1a7e5ac34939f1491743d137cd5c7.svg";
export { ForwardRef as ReactComponent };